import React from 'react';
import { Alert, Box, Set } from 'bumbag';
import { Form, Formik } from 'formik';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'paym... Remove this comment to see the full error message
import payment from 'payment';
import Script from 'react-load-script';
import Loads from 'react-loads';

import ErrorMessage from '@medipass/react-core/components/ErrorMessage';
import PaymentCardInputs from '@medipass/react-core/PaymentMethods/PaymentCardInputs';
import { withRouter } from '@medipass/react-core/router';
import buildValidationSchema from '@medipass/utils/build-validation-schema';
import { ERROR_MESSAGES } from '@medipass/utils/constants';
import env from '@medipass/utils/get-env';
import { logError } from '@medipass/utils/sentry';
import sdk from '@medipass/web-sdk';

import SubmitCancelButtons from '../../SubmitCancelButtons';

type Props = {
  className?: string | null | undefined;
  formRef?: any;
  history: Record<string, any>;
  initialValues?: Record<string, any>;
  isMobileTitle?: boolean;
  isSelfCheckoutSession?: boolean;
  isSubmitButtonInsideSection?: boolean;
  onSubmit: (...args: Array<any>) => any;
  showSubmitButton?: boolean;
  submitButtonRenderer?: (...args: Array<any>) => any;
  title: string;
};
type State = {
  errorMessage: string | null | undefined;
};

class PaymentMethodForm extends React.Component<Props, State> {
  static defaultProps = {
    className: undefined,
    formRef: undefined,
    initialValues: {
      cardNumber: '',
      expiry: '',
      cvc: '',
    },
    isMobileTitle: true,
    isSelfCheckoutSession: false,
    isSubmitButtonInsideSection: false,
    showSubmitButton: true,
    submitButtonRenderer: undefined,
  };
  state = {
    errorMessage: undefined,
  };
  handleClickCancel = () => this.props.history.push('/account/payment-methods/');
  handleLoadGatewayError = () => {
    logError({
      message: 'HPF script failed to load',
    });
    this.setState({
      errorMessage: ERROR_MESSAGES.PAYMENT_GATEWAY_ERROR,
    });
  };
  submitPaymentMethod = async ({ cardNumber, expiry, cvc }: { cardNumber: string; expiry: string; cvc: string }) => {
    const { isSelfCheckoutSession, onSubmit } = this.props;

    try {
      const nonceResponse = await sdk.payments.getNonce({
        cardNumber,
        expiry,
        cvc,
        isSelfCheckoutSession,
      });

      return await onSubmit({
        source: (nonceResponse as any).source,
        nonce: (nonceResponse as any).nonce,
      });
    } catch (err) {
      logError(err);
      throw err;
    }
  };
  render = () => {
    const {
      className,
      formRef,
      initialValues,
      isSubmitButtonInsideSection,
      isMobileTitle,
      showSubmitButton,
      submitButtonRenderer,
      title,
    } = this.props;
    return (
      <Loads load={this.submitPaymentMethod}>
        {/* @ts-expect-error TS(7031): Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message */}
        {({ error, load: handleSubmitPaymentMethod, isLoading, isError }) => (
          <Box>
            <Script url={env.HPF_SCRIPT_URL} onError={this.handleLoadGatewayError} />
            <Formik
              ref={formRef}
              // @ts-expect-error TS(2322): Type 'Record<string, any> | undefined' is not assi... Remove this comment to see the full error message
              initialValues={initialValues}
              onSubmit={handleSubmitPaymentMethod}
              validationSchema={buildValidationSchema([
                {
                  name: 'cardNumber',
                  validators: [
                    { type: 'required', message: 'Please enter a card number' },
                    {
                      type: 'test',
                      message: 'Please enter a valid card number',
                      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
                      fn: value => payment.fns.validateCardNumber(value),
                    },
                  ],
                },
                {
                  name: 'expiry',
                  validators: [
                    { type: 'required', message: 'Please enter an expiry' },
                    {
                      type: 'test',
                      message: 'Please enter a valid expiry',
                      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
                      fn: value => payment.fns.validateCardExpiry(value),
                    },
                  ],
                },
                {
                  name: 'cvc',
                  validators: [
                    { type: 'required', message: 'Please enter a CVC' },
                    {
                      type: 'test',
                      message: 'Please enter a valid CVC',
                      // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
                      fn: value => payment.fns.validateCardCVC(value),
                    },
                  ],
                },
              ])}
            >
              {({ errors, handleChange, touched, values }) => (
                <Form noValidate>
                  {/* @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message */}
                  <Box className={className} marginBottom="major-2">
                    <Set display="block" orientation="vertical" spacing="major-2">
                      {title && (
                        <Box>{isMobileTitle ? <p className="font-semibold">{title}</p> : <h2>{title}</h2>}</Box>
                      )}
                      <PaymentCardInputs isRequired formType="formik" />
                      {isError && (
                        <Alert hasIcon variant="tint" type="danger">
                          <ErrorMessage description="Unable to add your payment card" err={error} />
                        </Alert>
                      )}
                      {isSubmitButtonInsideSection && showSubmitButton && (
                        <Box marginTop="major-3">
                          {submitButtonRenderer ? (
                            submitButtonRenderer({
                              isLoading,
                            })
                          ) : (
                            <SubmitCancelButtons
                              cancelText="CANCEL"
                              isLoading={isLoading}
                              onClickCancel={this.handleClickCancel}
                              submitText="SAVE"
                            />
                          )}
                        </Box>
                      )}
                    </Set>
                  </Box>
                  {!isSubmitButtonInsideSection && showSubmitButton && (
                    <Box>
                      {submitButtonRenderer ? (
                        submitButtonRenderer({
                          isLoading,
                        })
                      ) : (
                        <SubmitCancelButtons
                          cancelText="CANCEL"
                          isLoading={isLoading}
                          onClickCancel={this.handleClickCancel}
                          submitText="SAVE"
                        />
                      )}
                    </Box>
                  )}
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </Loads>
    );
  };
}

export default withRouter(PaymentMethodForm);
